<template>
  <div class="text-14 relative flex flex-col xl:flex-row rounded-lg overflow-hidden border-1 border-border border-solid mb-base shadow-card transition-all duration-150 hover:shadow-cardHover hover:bg-cardBackgroundHover">
    <div class="text-white bg-darkBlueBackground p-base xl:w-planCardHero" v-if="plan.id !== 'pay-as-you-go'">
      <b id="plan-card-plan-name">{{ plan.nickname }}</b>
      <p id="plan-card-plan-price">{{ $n(parseFloat(plan.price / 100), 'currency', plan.currency) }}</p>
    </div>
    <div class="text-white bg-darkBlueBackground p-base xl:w-planCardHero" v-else>
      <b id="plan-card-payg-name">{{ $t('companySettings.billing.payAsYouGoNoPunctuation') }}</b>
      <br />
      <span id="plan-card-payg-price">{{ paygPrice }}</span>
    </div>
    <div class="flex xl:w-planCardContent">
      <div class="p-base">
        <b id="plan-card-envelopes">{{ $t('functional.envelopes') }}</b>
        <p id="plan-card-plan-allowance">{{ plan.allowance ? plan.allowance : '-'}}</p>
      </div>
      <div class="p-base">
        <b>{{ $t('companySettings.billing.currentPlanSection.planFeatures') }}</b>
        <p>
          <span :id='`plan-card-features-${feature}`' v-for="feature in plan.scope" :key="feature">
            {{ $t(`companySettings.billing.plan.features.${feature}`) }},
          </span>
          <span>{{ $t('companySettings.billing.plan.features.templates') }}</span>
        </p>
      </div>
    </div>
    <div class="absolute top-0 right-0 p-base float-right">
      <VButton
          v-if="plan.id !== currentPlan.id"
          id="plan-card-switch-button"
          class="branding-buttons"
          size="small"
          type="outline-1"
          @click.native="openSwitchModal()"
          href="#"
          data-ec="billing_page"
          data-et="plan_switch_button">
        <span>{{ $t('functional.switch') }}</span>
      </VButton>
    </div>
  </div>
</template>

<script>


import VButton from '@/components/deprecated/atoms/Button.vue';

export default {
  name: 'BillingPlanCard',
  components: {
    VButton,
  },
  props: {
    plan: Object,
    currentPlan: Object,
    paygPrice: String,
  },
  methods: {
    openSwitchModal() {
      this.$emit('openModal');
    },
  },
};
</script>

